/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
/**
 * Вывод отчета о скорости загрузки.
 */
(function () {
  var onload = window.onload;
  var getCookie = function (name) {
    var matches = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    ))
    var value
    if (matches) {
      value = decodeURIComponent(matches[1])
      try {
        value = JSON.parse(value)
      } catch (e) {
      }
    }
    return value
  };
  window.onload = function () {
    if (typeof onload === 'function') {
      onload();
    }
    if (getCookie('performance_report_enabled')) {
      var timing = window.performance.timing;
      console.log('~~~~~~~~~ Load speed report ~~~~~~~~~~');
      console.log('Ответ сервера: ' + (timing.responseEnd - timing.navigationStart) / 1000 + 's');
      console.log('Загрузка DOM и исполнение JS: ' + (timing.domContentLoadedEventEnd - timing.navigationStart) / 1000 + 's');
      console.log('Загрузка DOM, стилей и скриптов: ' + (timing.domContentLoadedEventStart - timing.navigationStart) / 1000 + 's');
      console.log('Максимальное время загрузки: ' + (timing.loadEventStart - timing.navigationStart) / 1000 + 's');
      console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    if (app.isOffice && getCookie('is_gtm_connected')) {
      if (typeof gtm !== 'undefined' && gtm) {
        console.log('~~~~~~~~~ GTM подключен ~~~~~~~~~~');
      } else {
        console.log('~~~~~~~~~ GTM не подключен ~~~~~~~~~~');
      }
    }
  };
})();

}.call(window));